import classNames from "classnames";
import { ChevronDownIcon, ChevronUpIcon } from "@heroicons/react/24/outline";
import CiroButton, { CiroButtonStyleEnum } from "./CiroButton";

interface ICiroExpandableCard {
  title: React.ReactNode | null;
  collapsedContent: React.ReactNode | null;
  isOpen: boolean;
  setIsOpen: (value: boolean) => void;
  children: React.ReactNode;
}

const CiroExpandableCard = ({
  title,
  collapsedContent,
  children,
  isOpen,
  setIsOpen,
}: ICiroExpandableCard) => {
  return (
    <div
      className={classNames(
        "rounded-xl",
        "shadow-md",
        "border",
        "border-gray-200",
        "p-4",
        "bg-white",
        "transition-all",
        "duration-500",
      )}
    >
      <div className={classNames("flex", "justify-between", "items-start")}>
        <div>{title}</div>
        <CiroButton
          style={CiroButtonStyleEnum.UNSTYLED}
          onClick={() => setIsOpen(!isOpen)}
          analyticsField={"Toggle expandable card"}
        >
          {isOpen ? (
            <ChevronUpIcon
              className={classNames("h-6", "w-6", "text-zinc-500")}
            />
          ) : (
            <ChevronDownIcon
              className={classNames("h-6", "w-6", "text-zinc-500")}
            />
          )}
        </CiroButton>
      </div>

      <div
        className={classNames(
          "overflow-hidden",
          "transition-all",
          "duration-500",
          "ease-in-out",
          {
            "pt-4": isOpen,
            "pt-2": !isOpen,
          },
        )}
      >
        {isOpen ? children : collapsedContent}
      </div>
    </div>
  );
};

export default CiroExpandableCard;
